import { c as _c } from "react/compiler-runtime";
import 'ckeditor5/ckeditor5-content.css';
import './editor-viewer.scss';
import { cn } from '@core/utils';

/**
 * XSS 공격 방지를 위한 HTML sanitize 함수
 * - <script> 태그 제거
 * - onclick, onerror 등 이벤트 핸들러 속성 제거
 * - javascript: 프로토콜 제거
 */
const sanitizeHtml = (html: string): string => {
  return html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '').replace(/\s+on\w+\s*=\s*["'][^"']*["']/gi, '').replace(/\s+on\w+\s*=\s*[^\s>]+/gi, '').replace(/javascript:/gi, '');
};
interface EditorViewerProps {
  content: string;
  style?: React.CSSProperties;
  className?: string;
}
export const EditorViewer = t0 => {
  const $ = _c(10);
  const {
    content,
    style,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("editor-viewer ck-content min-h-54 text-left text-Gray-black", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== content) {
    t2 = sanitizeHtml(content);
    $[2] = content;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = {
      __html: t2
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== style || $[7] !== t1 || $[8] !== t3) {
    t4 = <div style={style} className={t1} dangerouslySetInnerHTML={t3} />;
    $[6] = style;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};